// extracted by mini-css-extract-plugin
export var container = "_4x-0";
export var containerTopRight = "_4x-1";